import $ from 'jquery';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';
import {is_ios,TUTIL,DATE_UTIL,sendAnalyticsInfo,xtract,SUTIL,tech_details_map,_str,changeFixButtonState,_attempted_fix_data,applyFix,software_use_events} from './util';
import {WTGORBIT,WTGFIXEDLINE} from './main-view';
import ui_settings from './ui_settings';
import {SPECTRUM} from 'wifi-spectrum/js/wifi-spectrum';
import TRACEROUTE from 'traceroute/js/traceroute';
import {speed_test} from 'speed-test/js/speedTest';
import async from 'async';
import c11n from 'wtg/c11n';
import H2GHISTORY from 'h2g-test-history/js/test-history';

angular.module('WTG.RESULTS',[])
.directive('resultInfo', function() {
 return {
  restrict: 'E',
  templateUrl: C11N.root_path+'h2g-test-results/templates/result-info.html'
 };
})
.directive('wtgTestResults', function() {
 return {
  restrict: 'E',
  templateUrl: C11N.root_path +'h2g-test-results/templates/test-results.html',
  controller:'testResultScreenCtrl'
 };
})
.directive('onScreenScroll', function() {
  return {
   restrict: 'A',
   link: function($scope, $elm, $attrs) {
    $elm.bind("scroll", function(/*evt*/) {
     $scope.$apply(function() {
      $scope.$eval($attrs.onScreenScroll);
     });
    });
   }
  };
 })
.factory('TESTRESULTS',function() {
 var test_results = {
  results : TR.results,
  get_component : function(){
   return TR.rsh.comp;
  },
  getRouteringTestResults: getRouteringTestResults,
  getWifiOptimizerTestResults : function getWifiOptimizerTestResults() {
   var t = TUTIL.get_test("wifi",'wifi_optimizer');
   if(!t) return {res_data:[],test:"wifi_optimizer",test_id:"",fix:"set_wifi_channel",details:""};
   var md = t[get_more_table(t.test)];
   return {
    res_data: md && JSON.parse(md),
    test: t.test, test_id: t.tid,
    fix:t.fix, details:t.details
   };
  },
  getTraceRouteResults : function get_data(){
   L.trace("getTraceRouteResults");
   var tr_data = {};
   if(!TR.results.internet) return;
   Object.values(TR.results.internet).forEach(function(t){
    if(!(t.test == "wifi_trace_route" || t.test == "mobile_trace_route")) return;
    var test_res = JSON.parse(t[get_more_table(t.test)]);
    var res_data = test_res;
    var dev_loc = test_res.d || {};
    tr_data = {results: res_data, test: t.test, time_stamp:t.ts, result:t.result, test_id:t.tid, dev_loc:dev_loc};
    //TRACEROUTE.tr_user.ts = tr_data.time_stamp;
   });
   return tr_data;
  },
 };
 return test_results;
})
.controller('testResultScreenCtrl', function($scope,$rootScope,WTGSPECTRUM,TESTRESULTS,spectrumData,tracerouteData,WTGDIALOG) {
 $scope.component = "";
 $scope.icon_more = WTG.img("more_vert_icon.svg");
 L.trace("$scope.icon_more--"+$scope.icon_more);
 $scope.icon_refresh = WTG.img("refresh_icon.svg");
 $scope.loader = WTG.img("three-dots.svg") ;
 $scope.tdc = _TDC;
 $scope.totalDisplayedItems = 4; //show number of items to be load on a list
 $scope.$on('LastRepeaterElement', function(){$rootScope.hideBusyScreen()});
 $scope.totalTests={};
 $scope.noTestResultFound = "";
 $scope.switch_channel_btn = $rootScope.strings.wifi_spectrum_btn_switch_channel;
 $scope.select_location = $rootScope.strings.select_location_btn;
 $scope.show_select_location_btn = C11N.nw_location;
 $scope.get_tip_btn = $rootScope.strings.wifi_spectrum_btn_get_tip;
 $scope.testResultsListWarn = $rootScope.strings.result_list_section_title_Warning;
 $scope.testResultsListWarns = $rootScope.strings.result_list_section_title_Warnings;
 $scope.testResultsListProb = $rootScope.strings.result_list_section_title_Problem;
 $scope.testResultsListProbs = $rootScope.strings.result_list_section_title_Problems;
 $scope.testResultsListOk = $rootScope.strings.result_list_section_title_OK;
 $scope.testResultsListIgnore = $rootScope.strings.result_list_section_title_Ignored;
 $scope.testResultsTurnedOffList =$rootScope.strings.result_list_section_title_turned_off;
 $scope.testResultsListManuals = $rootScope.strings.result_list_manual_tests;
 $scope.testResultsListManual = $rootScope.strings.result_list_manual_test;
 $scope.str_in_prog = $rootScope.strings.result_list_in_progress;
 $scope.str_enable = $rootScope.strings.result_list_enable;
 $scope.str_turn_on = $rootScope.strings.result_list_turn_on;
 $scope.str_execute = $rootScope.strings.result_list_execute;
 $scope.str_about = $rootScope.strings.about_dialog_header;
 $scope.isIos = is_ios();
 $scope.generic_btn_str_map = [];
 $scope.generic_btn_str_map[WTG.tr_scrn_btn.none]="";
 $scope.generic_btn_str_map[WTG.tr_scrn_btn.more]=$rootScope.strings.test_result_more_btn;
 $scope.generic_btn_str_map[WTG.tr_scrn_btn.fix]=$rootScope.strings.test_result_fix_btn;
 $scope.generic_btn_str_map[WTG.tr_scrn_btn.help]=$rootScope.strings.test_result_help_btn;
 $scope.generic_btn_str_map[WTG.tr_scrn_btn.reboot]=$rootScope.strings.test_result_reboot_btn;
 $scope.custom_order = {prob:1,warn:2,ok:3,manual:4,prog:5,turn_off:6,ignore:7};
 $scope.component = TESTRESULTS.get_component();
 $scope.update_test_results_header = function(){
  $scope.updateHeader = TR.rsh.header;
  $scope.iconPath = TR.rsh.icon1;
  $scope.arcIconPath = TR.rsh.icon2;
  $scope.changeLineClr = TR.rsh.header+'Border';
 };
// if(C11N.is_portal) $scope.update_test_results_header();
 // this is needed as navigating back from a different screen won't fill TR.rsh.comp
 if($scope.component != TR.rsh.comp) TR.rsh.comp = $scope.component;
 if(TR.rsh.prev_comp == 'errors') {
  TR.rsh.comp = TR.rsh.prev_comp;
  $scope.component = TR.rsh.prev_comp;
  TR.rsh.prev_comp = "";
 }
 L.trace("$scope.component - "+$scope.component);
 L.trace("TR.rsh.comp - "+TR.rsh.comp);
 if(_TDC){
  $rootScope.showBusyScreen("",_str("busy_screen_message"),_str("cancel_btn"));
 }
 if(TR.rsh.comp=="errors") {
  _allow_swipe = false;
  $scope.hideSubHeader = true;
 }
 else {
  $scope.update_test_results_header();
  if(!C11N.is_portal) setStatusBarColor($scope.updateHeader);
 }
 $scope.$on('$ionicView.enter', function(){
  $rootScope.hide_sub_header();
  H2GAPP.setTitle(false,(TR.rsh.comp=="errors")?TR.rsh.err_title:TR.rsh.title);
  sendAnalyticsInfo({id:software_use_events.results,details:TR.rsh.title});
 });
 $scope.$on('$ionicView.beforeLeave', function (/*event, viewData*/) {
  H2GAPP.setTitle(false,"");
 });
 $scope.canShowHelpBtn = function(testName,res_eval){
  return _TDC && is_ios() && (testName == 'wifi_signal' || testName == 'wifi_optimizer' || testName == 'routering') && (res_eval != 'manual') && (res_eval != 'prog') ;
 };
 $scope.validateSwithChannelOption = function(testName/*,component*/){
  // switch channel button is shown for wifi signal test for iOS for all brands
  // for TDC only this should be shown for routering test also for both Android and iOS
  // should validate routering test results
  if((is_ios()||C11N.is_ios) && ((testName == 'wifi_signal') || (_TDC && (testName == 'routering')))) {
   var routering_res = getRouteringTestResults();
   // L.trace("routeringIres"+ JSON.stringify(routering_res));
   return (routering_res && routering_res.res_data && routering_res.res_data.type && routering_res.result && routering_res.result == "ok");
  }
  //TODO: have a function to get component of a test
  return _TDC && ((testName == 'wifi_optimizer') || ((testName == 'wifi_signal' || testName == 'routering') && TR.results.wifi.wifi_optimizer));

 };
 $scope.isMoreBtn = function(status) { return (status==WTG.tr_scrn_btn.more) };
 $scope.isHelpBtn = function(status) { return (status==WTG.tr_scrn_btn.help) };
 $scope.isFixBtn = function(status) { return (status==WTG.tr_scrn_btn.fix) };
 $scope.isRebootBtn = function(status) { return (status==WTG.tr_scrn_btn.reboot) };
 $scope.onSwitchChannelBtnClick = function(){
  L.trace("onOpenWifiHelpScreen");
  if(is_ios()||C11N.is_ios) WTGSPECTRUM.validateRouter($rootScope,"",true);
  else ShowScreen("#/app/wifichannels");
 };
 $scope.select_user_location = function(){
  L.trace("select_user_location");
  WTGDIALOG.open_simple_dialog(WTGDIALOG.locationListCtrl, { header: $rootScope.strings.select_location_btn,
   body:  "",btn_two:$rootScope.strings.cancel_btn, btn_one: $rootScope.strings.ok_btn,
   controller: "showRadio",
   cb_two: function(){
    L.trace('-cbone-no-');
   },
   cb_one: function(val){
    L.trace('-cbone-yes-'+val);
    NativeAPI.call_engine('network.location.save',{n:val});
   }
  });
 };
 $scope.md_card_long_press = function(test,ev) {
  if(_allow_swipe)return;
  sendAnalyticsInfo({id:software_use_events.configure,details:test.testname});
  L.trace('Long press'+ev);
  $scope.processMenuItemsData(test,ev);
  WTGDIALOG.open_custom_dialog(WTGDIALOG.custom_popup,{ctrl: "showMoreInfoDialog",items: $scope.menuItems});
  sendAnalyticsInfo({id:software_use_events.test_menu,details:test.testname});
 };
 $scope.itemOnTouchEnd = function() {
  L.trace('Touch end');
 };
 $scope.md_card_move_right = function(testObj,key,index){
  if(_allow_swipe)return;
  var card_width = $('.tRScreencard'+key+index).width();
  $('.tRScreencard'+key+index).animate({marginLeft: card_width,marginRight: -card_width}, {
   duration: 500,
   start: function() {
    $('.tRScreencard'+key+index).addClass("positiveBg");
   },
   complete: function() {
    //L.trace("testObj - "+JSON.stringify(testObj));
    TR.changeUserActionStatus({tn:testObj.testname,comp:testObj.component}, user_actions.interested);
    // This array for restricting user removed test cards(interested) not coming again in test results screen until we go back to main screen.
    user_interested_tests.push(testObj.testname);
    $('.tRScreencard'+key+index).hide();
    var cur_count = parseInt($('.tRScreenCardsCount'+key).text())-1;
    $('.tRScreenCardsCount'+key).text(cur_count);
    sendAnalyticsInfo({id:software_use_events.user_interested,details:testObj.testname});
   }
  });

 };
 $scope.md_card_move_left = function(testObj,key,index){
  //L.trace("md_card_move_left--testObj.testname--"+JSON.stringify(testObj));
  if(_allow_swipe)return;
  var card_width = $('.tRScreencard'+key+index).width();
  $('.tRScreencard'+key+index).animate({marginLeft: -card_width ,marginRight: card_width}, {
   duration: 500,
   start: function() {
    $('.tRScreencard'+key+index).addClass("negativeBg");
   },
   complete: function() {
    TR.changeUserActionStatus({tn:testObj.testname,comp:testObj.component}, user_actions.not_interested);
    user_not_interested_tests[testObj.testname] = true;
    var cur_count = parseInt($('.tRScreenCardsCount'+key).text())-1;
    $('.tRScreenCardsCount'+key).text(cur_count);
    $('.tRScreencard'+key+index).hide();
    TR.evaluate();
    sendAnalyticsInfo({id:software_use_events.user_not_interested,details:testObj.testname});
   }
  });
 };
 $scope.onOpenIosWifiSpectrumHelpScreen = function(){
  L.trace("openIosWifiSpectrumHelpScreen");
  if(is_ios()) ShowScreen("#/app/WifiSpectrumHelp");
 };
 $scope.showVisualRoute = function(){
  ShowScreen("#/app/VisualTraceRoute");
 };
 $scope.doGenericBtnClick = function(testname,comp,btnTxt,testTitle,helpTxt,testId,fix,result_data){
  // L.trace("doGenericBtnClick--testname--"+testname);
  var obj={};
  obj.testTitle=testTitle;
  obj.helpTxt=helpTxt;
  obj.helpBtn = false;
  obj.comp = comp;
  obj.scTitle = $rootScope.strings.help_me_dialog_header;
  if(btnTxt == $rootScope.strings.test_result_more_btn && ui_settings && ui_settings[testname] && ui_settings[testname].more_fun) {
   // L.trace("ui_settings[testname].more_fun--"+ui_settings[testname].more_fun);
   if(ui_settings[testname].more_fun == '#/app/AppsUsage'){ //Here we check whether data (cpu,ram,battery) is available or not if available we can show appUsage screen(running apps) otherwise the MORE button will redirect to the Internet Consumption More Info screen.
    getAppsList(function(e,r) {
     if(e) {
      L.error({err:e},"error getting apps list");
      ShowScreen('#/app/AppsUsage');
     }
     $rootScope.appsInf=r;
     var showIntCons = true;
     for(var i in r.apps){
      if(r.apps[i].cpu || r.apps[i].ram || r.apps[i].battery){
       ShowScreen('#/app/AppsUsage');
       showIntCons = false;
       break;
      }
     }
     if(showIntCons) ShowScreen('#/app/AppsInternetUsage');
    });
   }
   else {
    if(!C11N.is_portal) {
     if(testname == "wifi_optimizer") spectrumData.set({history:false});
     if(testname == "wifi_trace_route" || testname == "mobile_trace_route") tracerouteData.set({history:false});
     ShowScreen(ui_settings[testname].more_fun);
     sendAnalyticsInfo({id:software_use_events.more_btn,details:testname});
    }
    else H2GRESULTS.open_screen_on_more_click(ui_settings[testname].more_fun,comp);
   }
  }
  else if(btnTxt == $rootScope.strings.test_result_fix_btn || btnTxt == $rootScope.strings.test_result_reboot_btn) {
   if(fix=="wifi_network_name_change") return $rootScope.show_generic_overlay(testname,{testTitle:testTitle,testname:testname,testId:testId,fix:fix});
   else if(fix=="wifi_router_login_page") return $rootScope.show_generic_overlay(fix,{testTitle:testTitle,testname:testname,testId:testId,fix:fix});
   else if(fix=="get_router_creds") {
    if(C11N.is_portal) return H2GDIALOG.show_generic_overlay('router_cred_overlay',{title:testTitle,tn:testname,testid:testId,fix:fix,rd:result_data});
    return show_router_dialog("","","",{title:testTitle,tn:testname,testid:testId,fix:fix,rd:result_data});
   }
   $scope.fix(testTitle,testname,testId,fix,result_data);
  }
  else if(btnTxt == $rootScope.strings.test_result_help_btn) {
   L.trace('doGenericBtnClick--HELP ME clicked');
   if(obj.helpTxt) setTimeout(function(){
    ShowScreen("#/app/HelpMe");
    $rootScope.sendHelpMeInfo(obj);
   },0);
  }
 };
 $scope.fix = function(title,tn,testid,fix,rd) {
  $("."+tn + "fixBtn").hide();
  $("."+tn + "fixImg").show();
  applyFix(title,tn,testid,fix,rd,$rootScope.strings.apply_fix_busy_state_dialog_header_title);
 };
 $scope.isCurrentFixTest = function(test){
  return test== _attempted_fix_data.testName;
 };
 $scope.isFixInProg = function(){
  return !!_attempted_fix_data.fix;
 };
 $scope.performManualTest = function(testName,params,testTitle,testID){
  if(C11N.is_portal) return $rootScope.performManualTest(testName,params,testTitle,testID);
  L.trace("performManualTest--testName--"+testName+" params-"+params);
  var str =$rootScope.strings.busy_state_dialog_header_title;
  str = WTG.fmt(str,{"test_name":testTitle});
  $rootScope.showBusyScreen("",str,$rootScope.strings.cancel_btn,null,testName);
  performTest_Fix(testName,params);
  sendAnalyticsInfo({id:software_use_events.retest,details:testName});

 };
 $scope.reTest = function(testName,params,testTitle){
  L.trace("resetTest--testName--"+testName+" params-"+params);
  if(testName == "end_to_end_speedtest") {
   params = JSON.stringify({rd:TUTIL.get_test_result_data("internet","end_to_end_speedtest")});
  }
  var str =_str("busy_state_dialog_header_title");
  str = WTG.fmt(str,{"test_name":testTitle});
  $rootScope.showBusyScreen("",str,$rootScope.strings.cancel_btn,null,testName);
  $("#testResultScreenBody").animate({ scrollTop: 0 }, "slow");
  if(C11N.is_portal) H2GRESULTS.run_test(testName, params);
  else {
   performTest_Fix(testName,params);
   sendAnalyticsInfo({id:software_use_events.retest,details:testName});
  }
 };
 $scope.processMenuItemsData = function(message/*,ev*/) {
  var obj={};
  obj.testName=message.testname;
  obj.component=message.component;
  message.more_btn_in_history=!C11N.is_portal && (ui_settings && ui_settings[message.testname] && ui_settings[message.testname].more_btn && ui_settings[message.testname].more_btn_in_history);
  obj.more_btn_in_history=message.more_btn_in_history || "";
  obj.moreDetails=message.more;
  obj.testTitle=message.Result_header;
  obj["eval"]=message.Result_evaluation;
  obj.showBtn=message.genericBtn;
  obj.genericBtnTxt=message.btnTxt;
  obj.testId=message.id;
  obj.notification_switch_status = true;
  obj.turned_off = false;
  function show_backup_restore() {
   if(_TDC || message.testname != "routering") return false;
   var routering_res = getRouteringTestResults();
   return (routering_res && routering_res.res_data && routering_res.res_data.type && routering_res.res_data.type=='TR64' && routering_res.result && (routering_res.result == "ok"));
  }
  function is_backup_present() {
   var routering_res = getRouteringTestResults();
   return (routering_res && routering_res.res_data && routering_res.res_data.type && routering_res.res_data.type=='TR64'
   && routering_res.result && (routering_res.result == "ok") &&
   routering_res.res_data.router_backup_available);
  }
  $scope.loaderImg = WTG.img("loader.svg");
  $scope.showBusyIcon = false;
  const showSettings = getTestSettingsValue(obj.testName);
  L.trace("show settings--"+JSON.stringify(showSettings));
  var is_periodic = is_periodic_test(obj.testName);
  var turn_off_test = obj.turned_off;
  $scope.settingItems = [
   {
    image: WTG.img("disabled_icon.svg"),
    title: _str("result_list_ignore"),
    id:"ignore_switch",
    show:true,
    disable:C11N.is_portal,
    showSwitch:true,
    switchStatus:false,
    testName:message.testname,
    busyIcon:false,
    onChange: function(item){
     L.trace('changes-inside');
     var ignore_status = item.switchStatus? 1:0;
     TR.changeIgnoredStatus(message.testname,message.component,ignore_status);
     TR.re_evaluate(TR.rsh.comp);
     TUTIL.set_ignored(message.testname,item.switchStatus);
    }
   },
   {
    image: WTG.img("disabled_icon.svg"),
    title: _str("settings_turn_off"),
    id:"turn_off_switch",
    show:true,
    disable:C11N.is_portal,
    showSwitch:true,
    switchStatus:turn_off_test,
    testName:message.testname,
    busyIcon:false,
    onChange: function(item){
     var dependent_tests = getDependentTests(message.testname);
     if(item.switchStatus){
      if(dependent_tests) {
       H2GDIALOG.enable_or_disable_turn_off_ctrl($scope,"turn_off_switch",false);
       L.trace(message.Result_header+"--dependent_tests--"+dependent_tests);
       var t = WTG.fmt(_str("turn_off_dependent_tests_warning"),{"test_name":message.Result_header,"dependent_tests":dependent_tests});
       WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{ header: _str("result_history_Warning"),
        body:t,"multiple" : true,btn_one: _str("ok_btn"),btn_two:_str("cancel_btn"),
        cb_one: function(){
         L.trace("warning_ctrl callback");
         H2GDIALOG.enable_or_disable_turn_off_ctrl($scope,"turn_off_switch",true);
         store_and_refresh_data(message.testname,message.component,item.switchStatus);
        }
       });
       }
       else{
        store_and_refresh_data(message.testname,message.component,item.switchStatus);
       }
      }
      else{
       NativeAPI.deleteData("user_settings.tests."+item.testName,"turn_off");
       store_and_refresh_data(message.testname,message.component,item.switchStatus);
      }
      function store_and_refresh_data(tn,comp,switchStatus){
       L.trace("store_and_refresh_data");
       TR.change_Turned_off_status(tn,comp,switchStatus);
       TUTIL.set_turned_off(tn,switchStatus);
       sendAnalyticsInfo({id:software_use_events.test_settings_changed,details:JSON.stringify({test:tn,setting:"turn_off_test",old:!switchStatus,'new':switchStatus})});
       TR.re_evaluate(TR.rsh.comp);
      }
    }
   },
   {
    id:"notifications",
    image: WTG.img("notifications_icon.svg"),
    title: _str("settings_notifications_desc"),
    show:true,
    disable:C11N.is_portal,
    showSwitch:true,
    switchStatus:message.notification_switch_status,
    busyIcon:true,
    testName:message.testname,
    onChange: function(item){
     SUTIL.setSetting("tests."+item.testName,"show_notifications",item.switchStatus);
     // TODO: avoid this hardcoded checks.
     // XXX: "LocalScan Notifier" test is not visible, but this is the one handles LocalScan notifications.
     // So i need to change settings for this test automatically when user changes settings for visible test "LocalScan"
     // I think we must have a mechanism(probably in tests.json) to know inter linked/dependent tests. so that we can avoid hard codes.
     if(item.testName=="LocalScan") SUTIL.setSetting("tests.LocalScan Notifier","show_notifications",item.switchStatus);
     //WTGDIALOG.close_dialog(); //don't close popup. let user see the change
     sendAnalyticsInfo({id:software_use_events.test_settings_changed,details:JSON.stringify({test:item.testName,setting:"show_notifications",old:!item.switchStatus,'new':item.switchStatus})});
    }
   },
   {
    image: WTG.img("settings_icon.svg"),
    title:showSettings.title,
    show:showSettings.bShow,
    disable:C11N.is_portal,
    onClick:  function(){
     $scope.showSettingScreen(message);
     WTGDIALOG.close_dialog();
    }
   },
   {
    image: WTG.img("settings_icon.svg"),
    title: _str("settings_set_interval"),
    show:is_periodic,
    disable:C11N.is_portal,
    onClick:  function(){
     L.trace("showSetIntervalSettingScreen--"+JSON.stringify(message));
     async.parallel({
      poll_interval: SUTIL.getPollInterval.bind(null,"tests."+message.testname,"poll_interval",60),
      poll_interval_screen_off: SUTIL.getPollInterval.bind(null,"tests."+message.testname,"poll_interval_screen_off",180),
     },function(e,r) {
        if(e){
         L.error({err:e},"error getting test poll intervals");
        }
        L.trace("setIntervalCtrl--r--"+JSON.stringify(r));
        if(r.poll_interval && r.poll_interval_screen_off) {
         $rootScope.MultiCtrlDialog(H2GDIALOG.setIntervalCtrl,{test:message,data:r} );
        }
     });
     WTGDIALOG.close_dialog();
    }
   }
  ];
  $scope.menuItems = [
   {
    image: WTG.img("settings_icon.svg"),
    title:_str("result_list_settings"),
    show:true,
    disable:C11N.is_portal,
    onClick:  function(){
     async.parallel({
      turned_off :TUTIL.get_turned_off.bind(null,message.testname)
     },function(e,r) {
      if(e) L.error({err:e},"error getting tests turned off status");
      L.trace("test_card_settings_ctrl--r--"+JSON.stringify(r));
      if(r.turned_off) obj.turned_off = r.turned_off;
      WTGDIALOG.open_custom_dialog(WTGDIALOG.custom_popup,{ctrl: "showMoreInfoDialog",items: $scope.settingItems});
     });
    }
   },
   {
    image: WTG.img("history_icon.svg"),
    title: _str("result_list_history"),
    show:true,
    disable:false,
    onClick: function(){
     WTGDIALOG.close_dialog();
     H2GHISTORY.showTestHistory(message);
    }
   },
   {
    image: WTG.img("expand_more_icon.svg"),
    title:_str("result_list_details"),
    show:message.more,
    disable:false,
    onClick: function(){
     var hide_btn_two = !(message.testname && (message.testname=="routering") && ui_settings && ui_settings[message.testname].get_logs_btn && (ui_settings[message.testname].get_logs_fun!=""));
     WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{ header: obj.testTitle+"  -  "+_str("result_list_details"),
      body:obj.moreDetails,btn_one: _str("ok_btn"),btn_two:(!hide_btn_two?_str("get_logs_btn"):""),
      cb_two: function(){
       L.trace("cb_two");
       applyFix(message.Result_header,message.testname,message.id,ui_settings[message.testname].get_logs_fun,"","");
       sendAnalyticsInfo({id:software_use_events.test_details,details:message.Result_header});
      }
     });
    }
   },
   {
    image: WTG.img("info.svg"),
    title:_str("result_list_about"),
    show:!(_TDC && (!message.about || message.about=="")),
    disable:C11N.is_portal,
    onClick:  function(){WTGDIALOG.close_dialog();$scope.onClickAbout(message.Result_header,message.about)}
   },
   {
    image: WTG.img("backup_icon.svg"),
    title:_str("backup_router_config"),
    show:show_backup_restore(),
    disable:C11N.is_portal,
    onClick: function(){
     WTGDIALOG.close_dialog();
     applyFix(message.Result_header,message.testname,getRouteringTestResults().test_id,"router_backup_restore",{"fix":"backup"},_str("apply_fix_busy_state_dialog_header_title"));
    }
   },
   {
    image: WTG.img("restore_icon.svg"),
    title:_str("restore_router_config"),
    show:show_backup_restore(),
    disable:C11N.is_portal,
    onClick: function(){
     WTGDIALOG.close_dialog();
     if(is_backup_present()) {
      applyFix(message.Result_header,message.testname,getRouteringTestResults().test_id,"router_backup_restore",{"fix":"restore"},_str("apply_fix_busy_state_dialog_header_title"));
     }
     else WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header: _str("restore_router_config"), body: _str("backup_not_available") , btn_one: _str("ok_btn")});
    }
   },
  ];
  $scope.showSettingScreen = function(test) {
   for(var item in ui_settings){
    if(test.testname == item){
     H2GDIALOG.showInputTemplate(H2GDIALOG.testSettingsCtrl,test );
     break;
    }
   }
  };
  $scope.onClickAbout = function(testTitle,about_text){
   L.trace("onClickAbout");
   ShowScreen("#/app/HelpMe");
   var hmi={};
   hmi.testTitle=testTitle;
   hmi.helpTxt=about_text;
   hmi.helpBtn = false;
   hmi.scTitle = _str("about_dialog_header")+" - "+testTitle;
   setTimeout(function(){ $rootScope.sendHelpMeInfo(hmi)},100);
   sendAnalyticsInfo({id:software_use_events.about_test,details:testTitle});
  };
  if(!C11N.is_portal){
   TUTIL.getTestNotificationSetting(message.testname,"show_notifications",function(e,r) {
    if(e) L.error({err:e},"Error at getTestNotificationSetting");
    else {
     obj.notification_switch_status = r;
    }
   });
  }
 };
 $scope.showMoreMenu = function(message,ev) {
  L.trace("showMoreMenu");
  $scope.processMenuItemsData(message,ev);
  WTGDIALOG.open_custom_dialog(WTGDIALOG.custom_popup,{ctrl: "showMoreInfoDialog",items: $scope.menuItems});
  if(!C11N.is_portal) sendAnalyticsInfo({id:software_use_events.test_menu,details:message});
 };
 $scope.chevDown = WTG.img("chevron_down.svg");
 $scope.toggleContent= function(test,ind) {
  if($scope.isContentShown(test)){
   $(".chevronDown"+ind).attr("src",$scope.chevDown);
   $scope.shownContent = null;
  }
  else {
   $(".chevronUp"+ind).attr("src",WTG.img("chevron_up.svg"));
   $scope.shownContent = test;
  }
 };
 $scope.increaseLimit = function () {
  //L.trace("increaseLimit--"+$scope.totalDisplayedItems);
  if ($scope.totalDisplayedItems < $scope.total_items) {
   $scope.totalDisplayedItems += 4;
  }
 };
 $scope.update = function update_data(comp){
  $rootScope.showBusyScreen("",$rootScope.strings.busy_screen_message,"");
  var tmp = {}, r;
  function getRes(obj) {
   r = obj;
   tmp = {
    testname: r.test,
    bShow: is_user_interested_test(r.component,r.test) &&
    (r.result!='manual' || hasSatisfyingPrerequisites(r.test)),
    Result_evaluation: r.turn_off ? "turn_off" : (r.ignore ? 'ignore' : r.result),
    Result_header: r.title,
    Result: r.details,
    fix: r.fix,
    result_data: r.result_data,
    about: r.about,
    ignore: r.ignore,
    turn_off: r.turn_off,
    time: r.time ||(DATE_UTIL.getTimeStampForUI(r.ts_last || r.ts)),
    help: r.help_me,
    id: r.id,
    component: r.component,
    ts: r.ts_last || r.ts,
    charging: r.charging
   };

   function getGenericBtnStatus(testName,evaluation,helptxt,fix,data) {
    var rd = data?JSON.parse(data):{};
    var status = WTG.tr_scrn_btn.none;
    // if MORE button has to be shown even though evaluation is warn/prob, check for more_priority in UI settings.
    // if not a high prio, go for evaluation and show either FIX/HELP ME based on fix information received from engine.
    // if evaluation is OK, and test has MORE button, show it.
    if(hasRebootBtn(testName)) return WTG.tr_scrn_btn.reboot;
    if(_TDC && (testName=="wifi_signal" || testName=="wifi_optimizer" || testName=="routering")) return WTG.tr_scrn_btn.none;
    if(rd && rd.hasOwnProperty("more_data_available") && rd.more_data_available==false){
     return (fix && (testName == "wifi_optimizer")) ? WTG.tr_scrn_btn.fix : WTG.tr_scrn_btn.none;
    }
    if(hasMoreBtnHighPriority(testName)) status = WTG.tr_scrn_btn.more;
    else if(TR.eval_compare_map[evaluation]>0) status = fix?WTG.tr_scrn_btn.fix:(helptxt?WTG.tr_scrn_btn.help:WTG.tr_scrn_btn.none);
    else if(hasMoreBtn(testName)) status = WTG.tr_scrn_btn.more;
    return status;
   }
   tmp.genericBtn = getGenericBtnStatus(tmp.testname,tmp.Result_evaluation,tmp.help,tmp.fix,tmp.result_data);
   tmp.genericBtnTxt = $scope.generic_btn_str_map[tmp.genericBtn];
   if(!H2GRESULTS.tdc) try {
    tmp.more = get_json_as_html( JSON.parse(tmp.result_data), tmp.testname );
   }catch(e) { tmp.more = tmp.result_data }
   return tmp;
  }
  function show(res) {
   if(!res) return L.error("Some error we didn't bother to provide a message for");
   var shown = res.filter(function(x) { return x.bShow });
   shown.sort(function (a, b) {
    return (
     ($scope.custom_order[a.Result_evaluation] - $scope.custom_order[b.Result_evaluation])
     || (+b.ts - +a.ts)
     || a.Result_header.localeCompare(b.Result_header)
    );
   });
   if(!$scope.$$phase) $scope.$apply();
   $scope.totalTests = shown.reduce(function(p,c) {
    var re = c.Result_evaluation;
    if(p[re]) p[re].push(c);
    else p[re]=[c];
    return p;
   },{});
   $scope.total_items = 0;
   Object.keys($scope.totalTests).forEach(function(key){
    $scope.total_items += $scope.totalTests[key].length;
   });
   L.trace("$scope.total_items--"+$scope.total_items);
   if(!Object.keys($scope.totalTests).length) {
    $scope.noTestResultFound = $rootScope.strings.result_list_no_test_result_found;
   }
   else $scope.noTestResultFound = "";
   $rootScope.hideBusyScreen();
  }
  if(comp != "errors") show(Object.values(TR.results[comp]).map(getRes));
  else {
   getTestResultsByEvaluation(TR.evalz.prob,TR.evalz.warn,function(e,r){
    if(e) return L.error({err:e},"getTestResultsByEvaluation - error from cb");
    if(r) {
     TR.rsh.err_title = _TDC?(r.status=="prob"?$rootScope.strings.history_tdc_problems_found:$rootScope.strings.history_tdc_warnings_found):$rootScope.strings.test_result_header_issues_found;
     var status = r.r.length?r.s:"unknown";
     if(C11N.is_portal) {
      _allow_swipe = false;
      $scope.hideSubHeader = true;
      $scope.errorScreenEvaluation=status;
     }
     else setStatusBarColor(status);
     show(r.r.map(getRes));
    }
    else L.warn("getTestResultsByEvaluation - something wrong. no result from callback");
   });
  }

 };
 $scope.showArrow= function(key,index) {
  var ll=2; //ll- limited lines.
  //ToDo : Need to debug more to find out the main route cause of this error.
  //currently i have added validations only. this is a temporary fix.
  var line_height = $("."+key+index).css('line-height');
  var lh = line_height ? parseInt(line_height.slice(0,-2)):20; // here 20 is default height of an element.
  var elementHeight =$('.'+key+index).outerHeight();
  var lines = Math.floor(elementHeight/lh);
  if(lines>ll) $('.mLeft'+index).css("margin-left", "-1.250rem");
  return (lines>ll);// it returns true to show arrow to expand the content.
 };
 $scope.isContentShown = function(test) {
  return $scope.shownContent === test;
 };
 if($scope.component == "errors" || TR.results[$scope.component]) $scope.update($scope.component);
 else $scope.noTestResultFound = $rootScope.strings.result_list_no_test_result_found;

}, false)
.directive('screenScroll', function ($parse) {
 return function ($scope, element, attrs) {
  var handler = $parse(attrs.screenScroll);
  element.scroll(function (/*evt*/) {
   var scrollTop = element[0].scrollTop,
   scrollHeight = element[0].scrollHeight,
   offsetHeight = element[0].offsetHeight;
   if (scrollTop === (scrollHeight - offsetHeight)) {
    $scope.$apply(function () {
     handler($scope);
    });
   }
  });
 };
});

var WTG_TR = function() {
 this.recents; // content of recents table of test results
 this.results={}; //for processing test results
 this.expired={};//for expiring test results
 this.eval_compare_map = {"prob":2,"warn":1,"ok":0,"prog":-1,"unknown":-2};
 this.states=["prob","warn","ok"];
 this.evalz;
 this.testGroupMapping = {"device":{"group1":"device","group2":"device","header_title":""},
 "wifi_router":{"group1":"router","group2":"router","header_title":""},
 "internet":{"group1":"internet","group2":"internet","header_title":""},
 "mobile_bs":{"group1":"network","group2":"network","header_title":""},
 // TODO: titles should be from strings.
 "wifi":{"group1":"device","group2":"router","header_title":"WiFi Network"},
 "fixed_line":{"group1":"router","group2":"internet","header_title":"Fixed Line Network"},
 "mobile_bb":{"group1":"network","group2":"internet","header_title":"Mobile Backbone"},
 "mobile":{"group1":"device","group2":"network","header_title":"Mobile Network"}};
 //this.tr_data = {}; //XXX: really necessary ???
 this.summary = {"prob":"#E8241A","warn_ok":"#FFFFFF"};
 this.tests = {}; // content of tests.js from storage
 this.rsh = { // result screen header
  title:"",
  comp:"",
  prev_comp:"",
  header:"",
  icon1:"",
  icon2:"",
  err_title:""
 };
 this.setResults = function(r) { // portal will set results after fetching from engine
  this.results = r;
 };
 this.setTestsConfiguration = function(e,r) { // portal will set configuration of all tests
  if(e) L.trace({err:e},"setTestsConfiguration error - "+e);
  else TR.tests = r;
 };
 this.setResultScreenHeaderInfo = function(obj) {
  this.rsh.title = obj.title;
  this.rsh.comp = obj.comp;
  this.rsh.header = obj.header;
  this.rsh.icon1 = obj.icon1;
  this.rsh.icon2 = obj.icon2;
  L.trace("rsh - "+JSON.stringify(this.rsh));
 };
 this.updateResultScreenHeaderInfo = function(id) {
  if(!id) return L.warn("no id to set header info");
  //L.trace("id-"+id);
  if(id == "errors") return; // for errors, we don't show header. so no need to update.
  // TODO: avoid these adjustments for component names.
  if(id == "wifi_router") id = "router";
  else if(id == "mobile_bs") id = "network";
  var cv = WTG.circular_view;
  var connector;
  var od;
  if(cv) {
   if((od = WTGORBIT.get_orbiter(id))) {
    connector = false;
   }
   else if((od = WTGORBIT.get_connector(id))) {
    connector = true;
   }
   //L.trace("orbit data - "+JSON.stringify(od));
   this.rsh.title = od.t;
   this.rsh.comp = od.n;
   if(connector) {
    var ad = WTGORBIT.arc_data(od.a);
    if(!ad) return;
    //L.trace("arc_data - "+JSON.stringify(ad));
    this.rsh.header = ad.state;
    this.rsh.icon1 = ad.ArcIcon1;
    this.rsh.icon2 = ad.ArcIcon2;
   }
   else {
    this.rsh.header = od.updateHeader;
    this.rsh.icon1 = _TDC?od.img:od.reportScreenIcon;
    this.rsh.icon2 = "";
   }
  }
  else {
   connector = WTGFIXEDLINE.components[id].c1 && WTGFIXEDLINE.components[id].c2;
   this.rsh.title = _str(WTGFIXEDLINE.components[id].t_id);
   this.rsh.comp = WTGFIXEDLINE.components[id].n;
   this.rsh.header = WTGFIXEDLINE.components[id].e;
   var img1 = WTG.img("rs_"+id+".png");
   var img2 = "";
   if(connector) {
    img1 = WTG.img("rs_"+WTGFIXEDLINE.components[id].c1+".png");
    img2 = WTG.img("rs_"+WTGFIXEDLINE.components[id].c2+".png");
   }
   this.rsh.icon1 = img1;
   this.rsh.icon2 = img2;
  }
 };
 this.re_evaluate = function (comp) {
  //L.trace("re_evaluate - "+JSON.stringify(TR.evalz));
  TR.evaluate();
  //L.trace("re_evaluate done - "+JSON.stringify(TR.evalz));
  TR.updateResultScreenHeaderInfo(comp);
  setStatusBarColor(TR.rsh.header);
  H2GRESULTS.update(comp);
 };
 function add(testResultObj,bRemove) {
  //  L.trace("addTestResults - results - "+JSON.stringify(testResultObj));
  var tr = TR.results;
  var c = testResultObj.component|| "";
  var t = testResultObj.test || "";
  // Because of async.parallel calls some times we are getting test done event before progress event.
  //Then in local structure test done events replacing with progress events.That's why those tests long time showing in progress state in GUI.
  //we want to eliminate this using timestamp but lot of cases we are getting same timestamps for progress and test done events.
  // In that cases we are avoiding progress events using comparing with table ids.

  //   L.trace("ui_ts--"+testResultObj.ui_ts+"--Remove--"+bRemove+"--result--"+testResultObj.result+"----test---"+t+"--comp---"+c);

  if(tr[c] && tr[c][t] && (+tr[c][t].ui_ts > +testResultObj.ui_ts ) ) return L.trace("current-- This is an old result and also we got latest result for this test--"+t);
  else if(TR.expired[c] && TR.expired[c][t] && (+TR.expired[c][t].ui_ts > +testResultObj.ui_ts )) return L.trace("expired-- This is an old result and also we got latest result for this test----"+t);

  if(tr[c] && tr[c][t]) {
   L.trace("addTestResults - delete test "+t+" from component "+c);
   delete TR.results[c][t];
  }

  if(!bRemove || testResultObj.turn_off) { // we must show turned OFF tests though expired. so user can turn them ON
      // check test in tests.json before adding them to allTestResults.
   // XXX: fix storage calls to not to create table while fetching data.
   // so can avoid checking for test title.
   //testResultObj.result["user_action"]= user_actions.default_value;
   if(user_not_interested_tests[t] ){
    //   L.trace("user_not_interested_tests."+t);
    testResultObj.ignore=1;
   }else {
    testResultObj.user_action= user_actions.default_value;
   }
   if(C11N.is_portal || (TR.tests[t] && TR.tests[t].title)) {
    if(!tr || !tr[c]) tr[c] = {};
    tr[c][t] = testResultObj;
    //L.trace("addTestResults - results - "+JSON.stringify(tr));
   }
   else return L.trace("addTestResults-"+t+"-not found in configuration");
   if( testResultObj.result!='manual' &&
   (window.location.href.indexOf("TestHistory")>=0) &&
   H2GAPP.is_history_for(c,t) ) {
    updateTestHistoryScreen(testResultObj);
   }
  }
  else {
   L.trace("addTestResults - "+t+" - is an expired test. don't add.");
   if(!TR.expired || !TR.expired[c]) TR.expired[c] = {};
   TR.expired[c][t]={tid:testResultObj.tid,result:testResultObj.result,ts:testResultObj.ts,ui_ts:testResultObj.ui_ts};
   //L.trace("expired-"+t+",Results-"+JSON.stringify(TR.expired));
   if(!C11N.is_portal && _attempted_fix_data.testName == t) _attempted_fix_data = {};
  }
 }
 this.evaluate = function (bRefreshTestResults,eval_on_demand) {
  if(!C11N.is_portal && !eval_on_demand && WTG.circular_view && (_bEvaluationSkipped = !bOrbitReady) )
   return L.warn('evaluateTests() - Orbit not ready');
  WTG.in_progress_tests = [];
  TR.evalz = { components:{}, prob: {}, warn: {} };
  for(var comp in TR.results) {
   for(var test in TR.results[comp]) {
    var r = TR.results[comp][test];
    var rr = r.result, rt = r.test;
    if(c11n.features.vpn) {
     if(rt=='vpn_on' && rr=='ok') TR.evalz.show_vpn=true;
     if(rt=='corporate_servers') TR.evalz.corps=true;
    }
    if(r.turn_off || r.ignore || rr=='manual' || r.user_action == 0) continue;
    if(rr=='prog' && WTG.in_progress_tests.indexOf(r.title) == -1 ) WTG.in_progress_tests.push(r.title);
    var rc = r.component;
    if(rc) { /* TODO: this is an unreadable piece of logic, I'm sure it could be done clearer */
    if(TR.evalz.components[rc]) {
     if(TR.eval_compare_map[rr] > TR.eval_compare_map[TR.evalz.components[rc]])
      TR.evalz.components[rc] = rr;
    }else TR.evalz.components[rc] = rr;
   }else L.warn({test:rt},"Test "+rt+" has no component");
   if(rr==TR.states[0] || rr==TR.states[1]) { // prob or warn
    if(TR.evalz[rr][rt]) TR.evalz[rr][rt].push(rt);
    else TR.evalz[rr][rt] = [rc];
   }
  }
 }
 if(C11N.is_portal) return;
 //L.trace("evalz - "+JSON.stringify(TR.evalz));
 resetData();
 for(var c in TR.evalz.components) evaluateComponent(c,TR.evalz.components[c],!!TR.evalz.show_vpn);
 /* Not using at the moment.
 if(TR.evalz.corps) evaluateCorpServer();
 */
 prepareEvaluationSummary(TR.evalz);
 // if(main_screen_progress)checkAndShowInprogressTestsInfo();
};
this.retrieveRecentTests = function (cb) {
 // L.trace("retrieveRecentTests");
 get_json("test_results.recent",function(err,data) {
  if(err) return cb && cb(err);
  //recentTests = data;
  TR.recents = data;
  cb && cb();
 });
};
this.ProcessResult = function (payload) {
 var bWaiting = payload.name && closeBusyState(payload.name);
 if(payload.error == "prerequisites") {
  L.warn("prerequisites for - "+name+ " - aren't satisfied");
  if(bWaiting) {

   H2GDIALOG.showInputTemplate(H2GDIALOG.popupCtrl,
    {"header":_str('alert'), "status":WTG.fmt(_str('test_perform_error_prerequisites'),{"testname":_str("id_"+name)})});
   }
   return;
  }
  this.updateResult(payload,function(/*e,r*/) {
   //L.trace("refresh test results screen");
   if(window.location.href.indexOf("TestResultScreen")>=0 &&
   ((TR.rsh.comp == payload.component) || (TR.rsh.comp == "errors"))) {
    if(TR.rsh.comp != "errors") {
     TR.updateResultScreenHeaderInfo(TR.rsh.comp);
     H2GRESULTS.update_test_results_header();
     setStatusBarColor(TR.rsh.header);
    }
    H2GRESULTS.update(TR.rsh.comp);
   }
  });
 };
 this.updateResult = function (payload,cb) {
  var name = payload.name;
  var comp = payload.component;
  var id = payload.id;
  var bFix = payload.isfix;
  var ui_ts = payload.ui_ts; //UI timestamp
  if(bFix) {
   L.trace("This a FIX result");
   if(name==_attempted_fix_data.fix) {
    var tmp = _attempted_fix_data;
    _attempted_fix_data = {};
    changeFixButtonState(tmp.testName);
    if(C11N.is_portal) H2GRESULTS.retriveFix(name,id,tmp.title);
    else retrieveFixResult(name,id,tmp.title);
   }
  }
  else retrieveTestResult(name,comp,id,ui_ts,(payload.tr||""),!C11N.is_portal,false,cb);
 };
 // TODO: handle retrieval of fix and test results in one common function
 function retrieveFixResult(fix,fixId,title) {
  get_json("fix_results.tests."+fix+"."+fixId,function(err,fixData){
   //have separate conditions for logging
   if(err) L.error("retrieveFixResult-error-"+err);
   else if(fixData) {
    // L.trace("retrieveFixResult-fixData-details-"+fixData.details);
    // L.trace("retrieveFixResult-fixData-title-"+title);
    if(!_TDC) {
     var scope = angular.element($('#appScreensContainer')).scope();
     if(scope) {
      scope.hideBusyScreen();
      if(fixData.details) setTimeout(function() { scope.show_generic_overlay('generic_info',{title:title,desc:fixData.details,btn:_str('ok_btn')})},0);
      else scope.close_overlay();
     }
     else L.warn("no scope");
    }
   }
   else L.warn("retrieveFixResult-fixData not valid");
   if(_TDC) updateFixDoneScreenData(fixData);
  });
 }
 function retrieveTestConfig(test,cb) {
  if(TR.tests[test] && TR.tests[test].title) return cb(null,TR.tests[test]);
  get_json("tests.tests."+test,cb);
 }
 function update_speed_test_screen(/*test*/){
  NativeAPI.speedtest_capabilities(function(e,r){
   if(e) L.error({err:e},"Error at getting  speedtest capabilities");
   L.trace("$rootScope.capabilities--r---"+JSON.stringify(r));
   if(r && Object.keys(r).length){
    var scope = angular.element($('#appScreensContainer')).scope();
    if(scope) {
     scope.capabilities = r;
     setTimeout(function() {scope.$apply() }, 0);
    }
    speed_test.refresh_screen(r);
   }else L.trace("speed test don't have any capabilities");
  });
 }
 function retrieveTestResult(test,comp,testId,ui_timestamp,res,bEvaluate,check_settings,cb) {
  async.parallel({
   results: function(cb) {
    if(res) return cb(null,JSON.parse(res));
    if(!testId) return cb(null,"notfound");
    get_json("test_results.tests."+test+"."+testId,function(e,r){
     if(e && e.reason=="notfound") cb(null,e.reason);
     else cb(e,r);
    });
   },
   ignored: function(cb) {
    if(!check_settings) return cb(null,false);
    TUTIL.get_ignored(test,cb);
   },
   test_cfg: function(cb) {
    if(C11N.is_portal) return cb(null,null);
    retrieveTestConfig(test,cb);
   },
   turned_off: function(cb) {
    if(!check_settings) return cb(null,false);
    TUTIL.get_turned_off(test,cb);
   }
  },function(e,r) {
   if(e||!r) {
    if(cb) cb(e,r);
    return L.error({err:e,r:r},"Failed to retrieve test data-"+test);
   }
   TR.tests[test] = r.test_cfg;
   var tt;
   if(r.results == "notfound") {
    if(xtract(TR.tests,test+".triggered_by.manual")) {
     L.trace({t:test},"a manual test "+test);
     tt = xtract(TR.tests,test+".title");
     add({test:test,title: tt? _str(tt):test,
      result: 'manual',
      about:_str('id_'+test+'_about'),
      component: comp,
      ui_ts:ui_timestamp,
     },false);
    }
    else {
     L.trace(test+" - not found in storage. remove from component - "+comp);
     add({component:comp,test:test,ui_ts:ui_timestamp},true);
    }
    if(cb) cb(null,C11N.is_portal?TR.results:null);
    return;
   }
   var testData = r.results;
   testData.tid = testId;
   testData.ui_ts = ui_timestamp;
   if(check_settings) {
    testData.ignore = r.ignored;
    testData.turn_off = r.turned_off;
   }
   //L.trace("retrieveTestResult-test-"+test+",testData-"+JSON.stringify(testData));
   var bRemove = false, bManualTest = false;
   if(!testData.component) {
    L.warn({t:test,r:testData},"not adding test "+test+"results as it has no component");
    bRemove = true;
   }else if(!testData.expired) {
    if( (bRemove = !c11n.features.vpn && isCorporateTest(test)) )
     L.warn({t:test,r:testData},"not adding a corporate test "+test+" results");
   }else{
    // L.trace({t:test},"found expired data for test "+test);
    bRemove = true;
    var bInvalid = (!c11n.features.vpn && isCorporateTest(test));
    if(bInvalid) r.turned_off = false;
    if(xtract(TR.tests,test+".triggered_by.manual")) {
     L.trace({t:test},"a manual test "+test);
     bManualTest = true;
     tt = xtract(TR.tests,test+".title");
     add({test:test,title: tt? _str(tt):test,
      result: 'manual',
      about:_str('id_'+test+'_about'),
      component: comp,
      ui_ts:ui_timestamp,
     },bInvalid);
    }
   }
   if(!bManualTest) {
    testData.time = DATE_UTIL.getTimeStampForUI(testData.ts_last || testData.ts);
    testData.tid = testId;
    testData.test = test;
    add(testData,bRemove);
   }
   if(bEvaluate) {
    TR.evaluate();
    // we need this for trace route results screen live update
    setTimeout(function() {
     if(window.location.href.indexOf("VisualTraceRoute")>=0 &&
     (!testData.expired && (test=="wifi_trace_route" || test=="mobile_trace_route"))){
      TRACEROUTE.draw_traceroute_for_user_ip();
     }
     if(!C11N.is_portal && !testData.expired && (test=="routering" || test == "mobile_connection_state")){
      if(window.location.href.indexOf("SpeedTest")>=0 ) update_speed_test_screen(test);
      if(window.location.href.indexOf("wifichannels")>=0 ) SPECTRUM.refresh_screen(test);
     }
    }, 5);
   }
   if(cb) cb(null,C11N.is_portal?TR.results:null);
  });
 }

 this.fillTestResults = function (bRefreshTestResults) {
  //L.trace("fillTestResults");
  /*recentTests = {"device": {"flight_mode":1,"test_manual":0}};
  var tests = {"flight_mode":{1:{"component":"device","conv_id":3380,"details":"Flight mode is disabled on your device","expired":false,
  "fix":false,"help_me":"","id":0,"input":"","more_info":"Once Airplane Mode is activated, your device turns off both the Wi-Fi and cellular connections. This means you will no longer be able to make or receive calls, texts, or e-mails, or browse the Internet",
  "order":1,"result":"ok","title":"Flight Mode","track":true,"tracked":false,"ts":1484114951}}};*/
  var components={};
  async.forEachOf(TR.recents,function(tests,comp,cb){
   async.forEachOf(tests, function(testid, test, callback){
    //L.trace("fillTestResults-test-"+test);
    components[test] = comp;
    if(!testid && testid !== "0") {
     L.warn("fillTestResults-"+test+"- has no test id.");
     callback();
    }
    else if(testid==="0") {
     //L.trace("Manual test-"+test);
     retrieveTestConfig(test,function(e,r){
      TR.tests[test] = r;
      add({test:test,"title":((TR.tests&&TR.tests[test]&&TR.tests[test].title)?_str(TR.tests[test].title):test),result:"manual",about:_str('id_'+test+'_about'),component:components[test]});
      callback();
     });
    }
    else {
     var ui_ts = new Date().getTime() || "NA";
     retrieveTestResult(test,comp,testid,ui_ts,"",false,true,function(e/*,r*/) {
      callback(e);
     });
    }
   }, function(err) {
    cb(err);
   });
  }, function(err) {
   if (err) L.error("error while iterating recentTests-error-"+err);
   var scope = angular.element($('#appScreensContainer')).scope();
   if(scope) scope.hideBusyScreen();
   TR.evaluate(bRefreshTestResults);
   //  getTraceRouteResults();
  });
 };
 this.changeUserActionStatus = function(obj,user_action_status) {
  if(user_action_status == user_actions.not_interested)
   TR.results[obj.comp][obj.tn].ignore = 1;
  else
   TR.results[obj.comp][obj.tn].user_action=user_action_status;
 };
 this.changeIgnoredStatus = function (tn,comp,ignore) {
  TR.results[comp][tn].ignore=ignore;
 };
 this.change_Turned_off_status = function(tn,comp,turned_off_status) {
  TR.results[comp][tn].turn_off=turned_off_status;
 };
 function isCorporateTest(testname) {
  return !!(TR.tests && TR.tests[testname] && TR.tests[testname].corporate);
 }
 /* Not using at the moment.
 function evaluateCorpServer() {
 var evaluation, res_data;
 for(var i=0;i<allTestResults.length;i++) {
 if(allTestResults[i].test == "corporate_servers") {
 evaluation = allTestResults[i].result.result;
 res_data = allTestResults[i].result && allTestResults[i].result.result_data && JSON.parse(allTestResults[i].result.result_data,true).corporate_servers;
 break;
}
}
if(res_data) {
for(var i=0;i<res_data.length;i++) {
if(res_data[i].eval == evaluation && res_data[i].icon) {
WTGORBIT.corp_server_icon(res_data[i].icon);
break;
}
}
}
WTGORBIT.corp_server_color(evaluation);
};
*/
function setEvaluationStatus(obj) {
 if(!WTG.circular_view) return WTGFIXEDLINE.set_status(obj);
 if(!obj.con) return WTGORBIT.set_status(obj.c1, obj.r);
 return WTGORBIT.make_orbiter({}).clearArc(obj.c1+"_"+obj.c2).changeArcColor(obj.c1,obj.c2,obj.r);
}
function evaluateComponent(compName,result,bShowVPNStatus) {
 if(!(compName && TR.testGroupMapping[compName]))
  return L.warn("Lacking or unknown component name: "+compName);
 var group1 = TR.testGroupMapping[compName].group1;
 var group2 = TR.testGroupMapping[compName].group2;
 if(group1 == group2){
  if(c11n.features.vpn && group1=="internet") WTGORBIT.lock_icon(group1,bShowVPNStatus);
  setEvaluationStatus({con:false,c1:group1,r:result});
 }
 else setEvaluationStatus({con:true,c1:group1,c2:group2,r:result});
 if(C11N.introduceProbsWarns) checkProbsWarnsIntroStatus(result);
}

function prepareEvaluationSummary(evalz) { //main message to show in the center of the circle
 $("#networkStatus").css("margin-top","0px");
 $("#updateWarningInfo").removeClass("font_22").addClass("two_limited_lines");
 if(WTG.circular_view && WTG.in_progress_tests.length) {
  L.trace("Tests in progress - "+JSON.stringify(WTG.in_progress_tests));
  // TODO: this can be improved
  /*
   This is to avoid showing tests in-progress state for shorter times which flickers with text and busy state.
   So, check after 2secs. if still in-progress, then show it.
  */
  if(!getSummary()) showSummary("","",true);
  else setTimeout(function() { if(WTG.in_progress_tests.length) showSummary("","",true); },2000);
  return;
 }
 if(Object.keys(evalz.prob).length) {
  setEvaluationSummary(evalz.prob,true);
 }
 else if(Object.keys(evalz.warn).length) {
  setEvaluationSummary(evalz.warn,false);
 }
 else if(WTG.auto_diagnose) {
  if(_TDC) $('#updateWarningInfo,#updateTapInfo').css('color',this.summary.warn_ok);
  //  $("#networkStatus").css("margin-top","10px");
  if(WTGORBIT.is_wide()) $("#updateWarningInfo").removeClass("two_limited_lines").addClass("font_22");
  showSummary(_str("main_all_good"),_str("main_no_problems"));
 }
 else {
  L.trace("auto_diagnose is false. not showing all good status");
  showSummary("","",false,true);
 }
}
function setEvaluationSummary(evalObj,bProb) {
 if(_TDC) $('#updateWarningInfo,#updateTapInfo').css('color',bProb?this.summary.prob:this.summary.warn_ok);
 // Show test result description in  evaluation summary instead of n problems/warnings, if all problems/warnings have same description
 // this generally happens for permissions denied case. when location permission is denied, "wifi at location" and "wifi optimizer" tests have same result. this logic will be useful in such cases.
 var str, desc;
 if(hasSameTextForAllErrs(evalObj)) {
  desc = getTestDescription(getFirstTest(evalObj));
  if(desc) str = bProb?WTG.fmt(_str('main_single_errors'),{"err_description":desc}):WTG.fmt(_str('main_single_warnings'),{"warn_description":desc});
  else str = bProb?_str('main_single_error_multiple_components'):_str('main_single_warning_multiple_components');
  showSummary(str,_str('main_tap_to_expand'));
 }
 else if(Object.keys(evalObj).length > 1) { //multiple errors/warnings
  if(hasMultipleComponents(evalObj)) {
   // changed this to 2 STR calls, so Michael don not miss these strings when auto generating stringz.js
   str = bProb?WTG.fmt(_str('main_multiple_errors'),{"err_count":Object.keys(evalObj).length}):WTG.fmt(_str('main_multiple_warnings'),{"warn_count":Object.keys(evalObj).length});
   showSummary(str,_str('main_tap_to_expand'));
  }
  else {
   // changed this to 2 STR calls, so Michael don not miss these strings when auto generating stringz.js
   // in this case, earlier we were showing component name instead of number  of errors/warnings
   str = bProb?WTG.fmt(_str('main_multiple_errors_single_component'),{"err_count":Object.keys(evalObj).length}):WTG.fmt(_str('main_multiple_warnings_single_component'),{"warn_count":Object.keys(evalObj).length});
   showSummary(str,_str('main_tap_to_expand'));
  }
 }
 else { // single error/warning
  if(hasMultipleComponents(evalObj)) {
   // changed this to 2 STR calls, so Michael don not miss these strings when auto generating stringz.js
   showSummary(bProb?_str('main_single_error_multiple_components'):_str('main_single_warning_multiple_components'));
  }
  else {
   // changed this to 2 STR calls, so Michael don not miss these strings when auto generating stringz.js
   desc = getTestDescription(getFirstTest(evalObj));
   if(desc) str = bProb?WTG.fmt(_str('main_single_errors'),{"err_description":desc}):WTG.fmt(_str('main_single_warnings'),{"warn_description":desc});
   else str = bProb?_str('main_single_error_multiple_components'):_str('main_single_warning_multiple_components');
   showSummary(str,_str('main_tap_to_expand'));
  }
 }
}
function hasSameTextForAllErrs(evalObj) {
 var testDesc,testDescPrev="";
 for(var eachTest in evalObj) {
  var r = TR.results[evalObj[eachTest][0]][eachTest];
  testDesc = r.details_short||r.details||"";
  if(testDescPrev && testDesc && (testDescPrev != testDesc)) return false;
  testDescPrev = testDesc;
 }
 return true;
}
function hasMultipleComponents(evalObj) {
 if(Object.values(evalObj).some(x=>(x.length>1))) return true;
 var prev=[];
 for(var eachTest in evalObj) {
  if(prev.length) {
   if(prev.length == evalObj[eachTest].length) {
    if(prev[0]!=evalObj[eachTest][0]) {
     return true;
    }
   }
  }
  prev=evalObj[eachTest];
 }
 return false;
}
function getTestDescription(obj) {
 var r = TR.results[obj.comp][obj.test];
 return r.details_short||r.details||"";
}
function getFirstTest(evalObj) {
 for(var eachTest in evalObj) {
  return {test:eachTest,comp:evalObj[eachTest][0]};
 }
}
};

export var TR = new WTG_TR();
/* all test results we save in allTestResults array for processing

allTestResults-[
{"test":"flight_mode",
"result":{"id":"1","tracked":true,"result":"ok","components":["device","internet"],"title":"Flight mode","details":"Flight mode is currently OFF","more_info":"You can turn ON or OFF the flight mode on your device","ignore":false,"fix":"","expired":false,"order":1}},
{"test":"ping",
"result":{"id":"1","tracked":true,"result":"prob","components":["wifi_router","internet"],"title":"Ping","details":"Ping failed","more_info":"to check internet","ignore":false,"fix":"","expired":false,"order":1}}
]
*/
function updateTestHistoryTimeStamps(history,testName,poll_interval) {
 for(var i=0;i<history.length;i++) {
  history[i].time = DATE_UTIL.getTimeStampForUI(history[i].ts_);
  if(C11N.detailedTimestampInHistory){
   //user initiated test
   if(history[i].initiator == WTG.testInitiator.user) history[i].time = WTG.fmt(_str('history_time_desc_manual'),{"timestamp":DATE_UTIL.getTimeStampForUI(history[i].ts_)});
   else if(history[i].ts_last && history[i].ts && (history[i].ts_last!=history[i].ts)) {
    //periodic test
    var ui_ts;
    if(TR.tests && TR.tests[testName] && TR.tests[testName].triggered_by && TR.tests[testName].triggered_by.periodic) {
     ui_ts = DATE_UTIL.getTimeStampForTestHistory(history[i].ts,history[i].ts_last);
     history[i].time = WTG.fmt(_str('history_time_desc_periodic'),{"timestamp_first":ui_ts.ts,"timestamp_last":ui_ts.ts_last,"interval":poll_interval});
    }
    else if(history[i].iterations && history[i].iterations>1) {
     ui_ts = DATE_UTIL.getTimeStampForTestHistory(history[i].ts,history[i].ts_last);
     history[i].time = WTG.fmt(_str('history_time_desc'),{"timestamp_first":ui_ts.ts,"timestamp_last":ui_ts.ts_last,"iterations":history[i].iterations});
    }
   }
  }
 }
 return history;
}
export function getTestHistory(testName,component,cb) {
 if(!cb) return L.error("no callback for getTestHistory");
 get_json("test_results.tests."+testName,function(err,testHistory) {
  if(err) {
   L.error({err:err},"test history-error-"+err);
   return cb(err);
  }
  var history=[];
  for(var eachTestId in testHistory) {
   // check component also
   // if no result found in the test result, consider it as incomplete
   // don't consider test results with 'prog' result
   if((!testHistory[eachTestId].result)||(testHistory[eachTestId].result == 'prog')||(testHistory[eachTestId].component!=component)) continue;
   if(!_TDC && testHistory[eachTestId].tol_info) {
    //if there is a .(dot) in the end of result string remove it.
    //add blank space between result string and tolerance string
    if(testHistory[eachTestId].details[testHistory[eachTestId].details.length] == '.') testHistory[eachTestId].details.replaceAt(testHistory[eachTestId].details.length,"");
    testHistory[eachTestId].details=testHistory[eachTestId].details+" "+testHistory[eachTestId].tol_info;
   }
   testHistory[eachTestId].ts_ = testHistory[eachTestId].ts_last || testHistory[eachTestId].ts;
   testHistory[eachTestId].id = eachTestId;
   history.push(testHistory[eachTestId]);
  }
  history.sort(function(a,b) { return (parseInt(b.ts_)-parseInt(a.ts_)) });
  SUTIL.getPollInterval("tests."+testName,"poll_interval",60,function(e,r) {
   if(e) L.error({err:e},"Error fetching poll interval");
   cb(null,updateTestHistoryTimeStamps(history,testName,r));
  });
 });
}
//get test history of all the tests done
// TODO: THIS SHOULD NOT BE HERE (likely, not anywhere)
export function getTestHistory_TDC() {
 angular.element($('#appScreensContainer')).scope().setTestHistory( allTestResults.reduce(function(p,c) {
  var r = c && c.result;
  var rr = r && r.result;
  if(rr && !(rr=='manual' || rr=='prog'))
   p[r.title] = r;
  return p;
 },{}) );
}

function getComponentByTestName(tn) {
 //L.trace("getComponentByTestName - "+tn);
 for (var comp in TR.results){
  //L.trace("comp - "+comp);
  //L.trace("tr - "+JSON.stringify(TR.results[comp][tn]));
  if(TR.results[comp][tn] && TR.results[comp][tn].test == tn) return comp;
 }
 return "";
}
function hasSatisfyingPrerequisites(tn) {
 if(!(TR.tests && TR.tests[tn])) {
  L.warn("no configuration for test - "+tn);
  return true;
 }
 if(!TR.tests[tn].prerequisites) return true;
 var prs=TR.tests[tn].prerequisites;
 if(prs) {
  //L.trace("prs - "+JSON.stringify(prs));
  for(var eachTest in prs) {
   var comp = getComponentByTestName(eachTest);
   if(comp && TR.results[comp] && TR.results[comp][eachTest]) {
    if((TR.results[comp][eachTest].result=="ok" && prs[eachTest]) ||
    ((TR.results[comp][eachTest].result=="warn" || TR.results[comp][eachTest].result=="prob") && !prs[eachTest]));
    else {
     L.warn("not OK with prerequisites");
     return false;
    }
   }
   else {
    if(prs[eachTest]) {
     L.warn("test must exist- not OK with prerequisites");
     return false;
    }
   }
  }
 }
 else L.warn("no valid Prerequisites found for-"+tn);
 return true;
}
export function getRouteringTestResults() {
 var t = TUTIL.get_test('wifi_router','routering');
 if(!t) return {};
 var res_data = t.result_data && JSON.parse(t.result_data)|| "";
 return {"res_data" : res_data, "test": t.test, "test_id": t.id, "details":t.details,"result":t.result};
}
export function getTestNameById(id,cb) {
 //L.trace("getTestNameById - id - "+id);
 function getName(tid) {
  for(var test in TR.tests) {
   //L.trace("test - "+test);
   if(TR.tests[test] && TR.tests[test].hasOwnProperty("ida_id") && TR.tests[test].ida_id == tid) return _str(TR.tests[test].title);
  }
  return id;
 }
 //L.trace("getTestNameById - from existing _tests");
 var n = getName(id);
 //L.trace("n - "+n);
 if(n!=id) return cb(null,n);
 L.trace("test name not found. get from storage");
 get_json("tests.tests",function(e,r) {
  if(e || !r) L.warn("error retrieving tests configuration");
  else TR.tests = r;
  return cb(null,getName(id));
 });
}

// TODO: refine this code. REMOVE THIS CODE FROM THIS MODULE
var test_status = [];
export function processTestStatus(payload) {
 //L.trace("processTestStatus - current array - "+JSON.stringify(test_status));
 //L.trace("processTestStatus - "+JSON.stringify(payload));
 if(!payload || !payload.tn || !payload.s) L.trace("processTestStatus - invalid data");
 if(payload.tn != "diagnosis") return;
 if(payload.s == 'prog') {
  if(test_status.indexOf(payload.tn) == -1) {
   test_status.push(payload.tn);
   //L.trace("processTestStatus - current array(after push) - "+JSON.stringify(test_status));
  }
  //else L.trace("processTestStatus - not pushing anything as already existing.");
 }
 else if(payload.s == 'done') {
  var ind = test_status.indexOf(payload.tn);
  if(ind != -1) test_status.splice(ind,1);
  //L.trace("processTestStatus - current array(after splice) - "+JSON.stringify(test_status));
 }
 //else L.trace("processTestStatus - invalid status for - "+payload.tn);
 //L.trace("processTestStatus - current array(size) - "+test_status.length);
 function check() {
  //L.trace("processTestStatus - check function - "+JSON.stringify(test_status));
  if(test_status.length == 0) {
   //L.trace("processTestStatus - close busy screen");
   var scope = angular.element($('#appScreensContainer')).scope();
   if(scope) scope.hideBusyScreen();
   // set and store timestamp
   storeData("test_results.last_diagnosed","end",new Date().getTime(),"time");
   storeData("test_results.last_diagnosed","status","done");
   if(scope) scope.set_timestamp(true);
  }
 }
 if(test_status.length == 0) check();
}
function is_user_interested_test(component,test){
 if(C11N.is_portal) return true;
 if(user_interested_tests.indexOf(test) != -1) return false;
 return (TR.results[component][test].user_action != 0);
}

export function getTestSettingsValue(currentTestName){
 if(!_TDC && ui_settings && ui_settings[currentTestName])
  return {bShow : ui_settings[currentTestName].show,title:_str(ui_settings[currentTestName].title)};
 return {bShow :false ,title:""};
}
export function is_periodic_test(test_name){
 return (TR.tests && TR.tests[test_name] && TR.tests[test_name].triggered_by && TR.tests[test_name].triggered_by.periodic) ;
}
// TODO: does not belong here
export function showResultsForSummary(bScreenAlreadyShown,e) {
 if(WTG.help_mode) return WTGORBIT.handle_help_mode_text_on_arcs(e);
 if((TR.evalz.prob && Object.keys(TR.evalz.prob).length) || (TR.evalz.warn && Object.keys(TR.evalz.warn).length)){
  TR.rsh.comp = "errors";
  ShowScreen("TestResultScreen");
 }
 else L.trace("All good !");
}

function hasRebootBtn(testName) {
 return !!(!C11N.is_portal && ui_settings && ui_settings[testName] && ui_settings[testName].reboot_btn);
}
function hasMoreBtn(testName) {
 if(!C11N.is_portal || (testName != "internet_consumption"))
  return !!(ui_settings && ui_settings[testName] && ui_settings[testName].more_btn);
}

function hasMoreBtnHighPriority(testName) {
 return (!C11N.is_portal || (testName != "internet_consumption")) &&
  !!(ui_settings && ui_settings[testName] && ui_settings[testName].more_btn && ui_settings[testName].more_priority);
}
function get_more_table(testName) {
 return (ui_settings && ui_settings[testName] && ui_settings[testName].more_table)?ui_settings[testName].more_table:"result_data"; // for now return result_data if entry is missing
}
export function getCurrent_NetworkID_BSSID(comp) {
 var r = TUTIL.get_test(comp||"wifi",'wifi_connection_state');
 return r && {network_id:r.network_id,bssid:r.bssid};
}
export function get_json_as_html(json_,testName,bAddBreak) {
 var details = "";
 for(var attrib in json_) {
  var lookup=isNaN(parseInt(attrib));
  if(lookup) {
   details += "<br><b>" + ((tech_details_map[testName] && tech_details_map[testName][attrib])||attrib) + "</b>: ";
  }
  if(typeof json_[attrib] === 'object') {
   bAddBreak = ((Array.isArray(json_[attrib]) && json_[attrib].length>1) && (typeof json_[attrib][0] !== 'object'));
   if(bAddBreak) details += "<br>";
   details += get_json_as_html(json_[attrib],testName,bAddBreak);
  }
  else if(typeof json_[attrib] === 'function') break;
  else {
   details += ((!(lookup || Array.isArray(json_))?"<br>"+attrib+" : ":"")+json_[attrib]+(bAddBreak?"<br>":""));
  }
 }
 return details;
}
function getTestResultsByEvaluation(testsObjProb,testsObjWarn,cb) {
 function fillResults(testsObj,ctx,cb) {
  var res = [];
  if(testsObj && Object.keys(testsObj).length) {
   for(var eachTest in testsObj) {
    res.push(TR.results[testsObj[eachTest][0]][eachTest]);
   }
   return cb(null,{s:ctx,r:res});
  }
  cb(null,{s:ctx,r:res});
 }
 if(_TDC) {
  if(testsObjProb && Object.keys(testsObjProb).length) {
   fillResults(testsObjProb,"prob",function(e,r){
    cb(null,r);
   });
  }
  else {
   fillResults(testsObjWarn,"warn",function(e,r){
    cb(null,r);
   });
  }
 }
 else {
  fillResults(testsObjWarn,"warn",function(e,r){
   var warn = r;
   fillResults(testsObjProb,"prob",function(e,r){
    if(!r.r.length) r = warn;
    else r.r = r.r.concat(warn.r);
    cb(null,r);
   });
  });
 }
}
function resetData(){
 if(WTG.circular_view && bOrbitReady) {
  setConnectionLineColor("device","network","unknown");
  setConnectionLineColor("network","internet","unknown");
  setConnectionLineColor("device","router","unknown");
  setConnectionLineColor("router","internet","unknown");

  setTestGroupStatus("device","unknown",true);
  setTestGroupStatus("router","unknown",true);
  setTestGroupStatus("network","unknown",true);
  setTestGroupStatus("internet","unknown",true);
 }
 else {
  WTGFIXEDLINE.reset();
 }
}
function checkProbsWarnsIntroStatus(result) {
 if(!isMainScreen()) return;
 if(!result){
  if(TR.evalz && TR.evalz.probs && Object.keys(TR.evalz.prob).length) checkProbsWarnsIntroStatus("prob");
  if(TR.evalz && TR.evalz.warn && Object.keys(TR.evalz.warn).length) checkProbsWarnsIntroStatus("warn");
  return;
 }
 if(result != "warn" && result != "prob") return;
 if(_probsWarnsIntroStatus.show && !_probsWarnsIntroStatus[result].shown) {
  if(!_probsWarnsIntroStatus.current) {
   _probsWarnsIntroStatus.current=result;
   showProbsWarnsIntro(result);
  }
  else if(_probsWarnsIntroStatus.current != result) _probsWarnsIntroStatus.next = result;
 }
}
function updateTestHistoryScreen(recentTestResultObj) {
  var appElement = document.querySelector('[ng-controller="TestHistoryController"]');
  if(appElement) {
   var scope = angular.element(appElement).scope();
   var history = scope.testHistory;
   if(!(history && history.length)) return L.error("something is wrong. no history to refresh !!");
   // considering top most element(at index 0) is the recent one as this is already sorted data.
   if(history[0].id == recentTestResultObj.id) history.splice(0,1);
   recentTestResultObj.result.id = recentTestResultObj.id;
   recentTestResultObj.result.ts_ = recentTestResultObj.result.ts_last || recentTestResultObj.result.ts;
   history.push(recentTestResultObj.result);
   history.sort(function(a,b) { return (parseInt(b.ts_)-parseInt(a.ts_)) });
   SUTIL.getPollInterval("tests."+recentTestResultObj.test,"poll_interval",60,function(e,r) {
    if(e) L.error({err:e},"Error fetching poll interval");
    scope.$apply(function() {
        scope.testHistory = updateTestHistoryTimeStamps(history,recentTestResultObj.test,r);
    });
   });
  }
  else {
   L.warn("updateTestHistoryScreen - no app element");
  }
 }
export var H2GRESULTS = {
 tdc : false,
 notification_data: null,
 applyFix:null,
 retriveFix:null,
 update: function update(comp) {
  var $scope = angular.element($('#testResultsScreen')).scope();
   if($scope && $scope.$$phase) L.trace("scope found");
  if($scope){
    $scope.update(comp);
    $scope.update_test_results_header();
    if(!$scope.$$phase) $scope.$apply();
   }
 },
 update_test_results_header : function(){
  var $scope = angular.element($('#testResultsScreen')).scope();
   if($scope){
    $scope.update_test_results_header();
    if(!$scope.$$phase) $scope.$apply();
   }
 },
 run_test:null,
 show_results : function(/*comp*/) {
  ShowScreen("TestResultScreen");
 },
 open_screen_on_more_click : null,
};

export default H2GRESULTS;
/* vim:set ts=4 sw=4 expandtab: */
